/* unplugin-vue-components disabled */import script from "./CleaveNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CleaveNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./CleaveNumberInput.vue?vue&type=style&index=0&id=65108c59&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65108c59"]])

export default __exports__